export enum ChartColor {
  Positive = '#03CEAA',
  Negative = '#FF2567',
  Neutral = '#bdb8b8',
}

export enum ChartTrendClass {
  Positive = 'positive',
  Negative = 'negative'
}

export interface ChartDataPoint {
  x: string;
  y: number;
}

export enum ChartType {
  Line = 'line',
  Bar = 'bar',
  Column = 'column'
}

export interface ChartData {
  type?: ChartType;
  data: ChartDataPoint[];
  name?: string;
}

export interface ChartSeries {
  series: ChartData[];
  colors: any[];
}

export interface BaseChart {
  destroy: () => void;
  render: () => void;
  update(
    newSeries: ChartSeries,
    animate?: boolean
  ): void;
}

export interface ChartAnnotation {
  points: ChartDataPoint[];
}
